import axios from 'axios';

export default axios.create({
  //  baseURL: 'https://localhost:10.85.39.10:81/api',
  // baseURL: 'http://185.196.20.44:8087/api',

  baseURL: 'http://c3wizardapi.stage.digitalnoticeboard.biz/api',
  // baseURL: 'https://c3wizardapis.ssb.digitalnoticeboard.biz/api',

  headers: {
    // 'Content-Type': 'application/json',
  },
});
